export { default } from './Paginator'
